export default __webpack_public_path__ + "static/media/by_10.850d03fd.mp3";